import React from "react";
import styled from '@emotion/styled'
import CandidateDetails from "./sections/CandidateDetails";
import CompanyProfile from "./sections/CompanyProfile";
import SenderDetails from "./sections/SenderDetails";
import { COLOR_MAP } from "../../../constants/ColorNames";
import OutreachDetails from "./sections/OutreachDetails";

const SideBar = styled.aside`
    /* min-width:33.4rem; */
    background-color: ${COLOR_MAP.WHITE};
    border-radius: 0.8rem;
    border: 0.1rem solid ${COLOR_MAP.BORDER_GREY};
    position: sticky;
    top: -10.5rem;
`

const Sidebar = () => {
    return <SideBar>
        <OutreachDetails/>
        <CandidateDetails />
        <CompanyProfile />
    </SideBar>
}

export default React.memo(Sidebar);
